export default [
    {
      name: 'index',
      path: '/',
      meta: { 
        title: 'pageTitle.index'
       },
      component: () => import('../views/index')
    },
    {
      name: 'time_clac',
      path: '/time_clac',
      meta: { 
        title: 'pageTitle.timeClac'
       },
      component: () => import('../views/tools/time-calc')
    },
    {
      name: 'id_photo_editor',
      path: '/id_photo_editor',
      meta: { 
        title: 'pageTitle.idPhotoEditor'
       },
      component: () => import('../views/tools/id-photo-editor')
    },
    {
      name: 'img_splitter',
      path: '/img_splitter',
      meta: { 
        title: 'pageTitle.imgSplitter'
       },
      component: () => import('../views/tools/img-splitter')
    },
    {
      name: 'stopwatch',
      path: '/stopwatch',
      meta: { 
        title: 'pageTitle.stopwatch'
       },
      component: () => import('../views/tools/stopwatch')
    },
    {
      name: '404',
      path: '*',
      meta: { 
        title: 'pageTitle.index'
       },
      component: () => import('../views/index')
    }
  ]